import React from "react";
import loginlogo from "../../../assets/images/login-logo.svg";
import loginBgGrid from "../../../assets/images/login-bggrid.svg";
import loginBgTotal from "../../../assets/images/login-bgtotal.svg";
import rightArrow from "../../../assets/images/right-arrow.svg";
import LoginForm from "./LoginForm";
import { useTranslation } from "react-i18next";
import CustomDropDown from "../Header/CustomDropDown";


const Login = ({ componentType }) => {
  if (
    window.location.pathname === "/login" &&
    sessionStorage.getItem("authToken")
  ) {
    window.location.href = "/invoice";
  }
  const { t } = useTranslation();
  return (
    <React.Fragment>
      <div className="login-layout">
        <div className="row mx-0 h-100vh">

          <div className="col-md-6 col-12 position-relative">
            <div className="d-flex align-items-center justify-content-between login-header">
              <div className="">
                <img src={loginlogo} alt="logo" />
              </div>
              <div className="page-header d-md-block login-page-header">
                
                <CustomDropDown />
              </div>
            </div>
            <div className="logincredential-section d-flex align-items-center justify-content-center h-100">
              <div className="pt-3">
                <div>
                  <h3 className="fs36 mt-15 mb-3">
                    {t("loginOrSignup")}
                  </h3>
                </div>
                <div>
                  <h2 className="page-heading text-left fs16 mb-0">
                    {t("loginWelcome")}
                  </h2>
                </div>
                <LoginForm />
              </div>
            </div>
          </div>
          <div className="col-md-6 col-12 login-form bg-gradient-blue bg-md-transparent d-none d-md-block">
            <div className="d-flex align-items-center justify-content-center h-100">
              <div className="text-white login-content">
                <div className="position-relative">
                  <img className="img-fluid" src={loginBgGrid} alt="" />
                  <img className="login-bgtotal img-fluid" src={loginBgTotal} alt="" />
                </div>
                <div>
                  <h3 className="fs22 poppins-semibold mt-3 mb-3">Welcome to IDP-AI from UpQuAI</h3>
                  <h4 className="fs14 poppins-regular mb-4">Where Technology meets Insurance Expertise</h4>
                  <div className="">
                   <a href="" className="fs14 poppins-medium d-inline-flex align-items-center justify-content-center">Read More<img className="ms-2" src={rightArrow} alt="" /></a>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </React.Fragment>
  );
};

export default Login;
